import { render, staticRenderFns } from "./SimulatorCurrencyInput.vue?vue&type=template&id=48999810"
import script from "./SimulatorCurrencyInput.vue?vue&type=script&lang=js"
export * from "./SimulatorCurrencyInput.vue?vue&type=script&lang=js"
import style0 from "./SimulatorCurrencyInput.vue?vue&type=style&index=0&id=48999810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
